// position: sticky causes a visible snap/ease effect when scrolling back to the top of the page.
// This controller uses position: fixed instead, with a same-height spacer element inserted after
// the banner to preserve document flow. Top offset is read from .nav__bar (which includes the
// ribbon when active) rather than a hardcoded value.
import { Controller } from "stimulus";

const MOBILE_BREAKPOINT = 600;

export default class extends Controller {
    spacer = null;

    connect() {
        this.spacer = document.createElement('div');
        this.element.insertAdjacentElement('afterend', this.spacer);

        window.addEventListener('resize', this.updateLayout);
        this.updateLayout();
    }

    disconnect() {
        window.removeEventListener('resize', this.updateLayout);
        this.spacer?.remove();
    }

    updateLayout = () => {
        if (window.innerWidth <= MOBILE_BREAKPOINT) {
            this.element.style.cssText = '';
            this.spacer.style.height = '';
            return;
        }

        const navBar = document.querySelector('.nav__bar');
        const navHeight = navBar ? navBar.offsetHeight : 97;

        this.element.style.position = 'fixed';
        this.element.style.top = `${navHeight}px`;
        this.element.style.left = '0';
        this.element.style.width = '100%';
        this.spacer.style.height = `${this.element.offsetHeight}px`;
    };
}
